import { frontendURL } from '../../../helper/URLHelper';
import KanbanView from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_index',
    component: KanbanView,
    meta: {
      permissions: ['administrator'],
    },
  },
];
